import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ProductSignUp from "segments/desktop/core-components/product-sign-up/product-sign-up.js";
import { WORK_MANAGEMENT_PRODUCT_ID, CRM_PRODUCT_ID, DEV_PRODUCT_ID } from "constants/products";
import { BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME, CRM_DARKER_TINT_02_COLOR_NAME, DEV_DARKER_TINT_02_COLOR_NAME, CRM_DARKER_TINT_02 } from "styles/color-consts";
import colors from "styles/colors";
import { StyledProductTabContentTagsComponent } from "./product-tab-content-tags-component.scss";
const PRODUCT_COLORS = {
    [WORK_MANAGEMENT_PRODUCT_ID]: "#D4D4FE",
    [CRM_PRODUCT_ID]: "#BEDDE3",
    [DEV_PRODUCT_ID]: "#D5EADE"
};
const PRODUCT_TEXTS_COLORS = {
    [WORK_MANAGEMENT_PRODUCT_ID]: BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME,
    [CRM_PRODUCT_ID]: CRM_DARKER_TINT_02,
    [DEV_PRODUCT_ID]: DEV_DARKER_TINT_02_COLOR_NAME
};
const PRODUCT_BUTTON_COLORS = {
    [WORK_MANAGEMENT_PRODUCT_ID]: BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME,
    [CRM_PRODUCT_ID]: CRM_DARKER_TINT_02_COLOR_NAME,
    [DEV_PRODUCT_ID]: DEV_DARKER_TINT_02_COLOR_NAME
};
const CTA_TEXT = {
    [WORK_MANAGEMENT_PRODUCT_ID]: "Try Work Management",
    [CRM_PRODUCT_ID]: "Try Sales CRM",
    [DEV_PRODUCT_ID]: "Try Dev"
};
const ProductTabContentTagsComponent = ({ tags, productType })=>{
    const productColor = PRODUCT_COLORS[productType];
    const productTextColor = PRODUCT_TEXTS_COLORS[productType];
    const productButtonColor = PRODUCT_BUTTON_COLORS[productType];
    const ctaText = CTA_TEXT[productType];
    return /*#__PURE__*/ _jsxs(StyledProductTabContentTagsComponent, {
        className: "product-tags-wrapper",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "product-tags-container",
                children: tags.map((tag, index)=>/*#__PURE__*/ _jsx("div", {
                        className: "product-tag",
                        style: {
                            backgroundColor: productColor,
                            color: colors[productTextColor]
                        },
                        children: tag.text
                    }, index))
            }),
            /*#__PURE__*/ _jsx(ProductSignUp, {
                buttonSize: "xs",
                productType: productType,
                buttonColor: productButtonColor,
                useCtaText: true,
                ctaText: ctaText,
                useCtaIcon: false,
                invert: true
            })
        ]
    });
};
export default ProductTabContentTagsComponent;
